import React from 'react';
import { connect } from 'react-redux';

import RufsError from '../../errors/rufsError.jsx';
import partnerPropTypes from '../../partnerPropTypes';

const ApproveItemError = ({ partner }) => (
    <RufsError>
        Vi kan ikke overføre pengene til {partner.name} akkurat nå. Prøv igjen
        om litt.
    </RufsError>
);

function mapStateToProps(state) {
    return {
        partner: state.partner,
    };
}

ApproveItemError.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default connect(mapStateToProps)(ApproveItemError);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/approveItemError.jsx